export const FETCH_LIST_ALL_DOCUMENTS_REQUEST = 'FETCH_LIST_ALL_DOCUMENTS_REQUEST'
export const FETCH_LIST_ALL_DOCUMENTS_SUCCESS = 'FETCH_LIST_ALL_DOCUMENTS_SUCCESS'
export const FETCH_LIST_ALL_DOCUMENTS_FALUIRE = 'FETCH_LIST_ALL_DOCUMENTS_FALUIRE'
export const FETCH_SEARCH_ALLDOC='FETCH_SEARCH_ALLDOC'